<template>
  <div class="card mb-4 p-3 shadow-sm border-0">
    <div class="row g-0 d-flex align-items-center flex-wrap">
      <!-- IMAGE -->
      <div class="col-md-4 text-center">
        <img :src="imgSrc" class="img-fluid rounded-start" :alt="title" />
      </div>

      <!-- TEXT CONTENT -->
      <div class="col-md-8">
        <div class="card-body text-center text-md-start">
          <h5 class="card-title" v-html="title"></h5>
          <p class="card-text" v-html="description"></p>
          <router-link v-if="false" :to="link" class="btn btn-orange">Learn More</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imgSrc: String,
    title: String,
    description: String,
    link: String
  },
 
};
</script>
